module.exports = __webpack_public_path__ + "img/image.6aa067b.png";